import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack"; // Add this import
const NotificationContext = React.createContext({
  showSuccess: (message: string) => {},
  showError: (message: string) => {},
});

const NotificationProvider = ({ children }: { children: React.ReactNode }) => {
  const { enqueueSnackbar } = useSnackbar();

  const showSuccess = (message: string) => {
    enqueueSnackbar(message, { variant: "success" });
  };

  const showError = (message: string) => {
    enqueueSnackbar(message, { variant: "error" });
  };

  return <NotificationContext.Provider value={{ showSuccess, showError }}>{children}</NotificationContext.Provider>;
};


export{NotificationContext, NotificationProvider}